export class CrearFuenteDto{
  nit : any;
	codigoSuperintendencia : any;
	codigoTipoEntidad : any;
	codigoEntidad : any;
	razonSocial : any;
	codigoDepto : any;
	codigoMpio : any;
	direccion : any;
	telefono : any;
	codigoEntidadFinanciadora : any;
	responsableChvNombre : any;
	responsableChvCargo : any;
	responsableChvTelefono : any;
	responsableChvCorreo : any;
  responsableInfoChvNombre : any;
	responsableInfoChvCargo : any;
	responsableInfoChvTelefono : any;
	responsableInfoChvCorreo : any;
	responsableFiviNombre : any;
	responsableFiviCargo : any;
	responsableFiviTelefono : any;
	responsableFiviCorreo : any;
  responsableInfoFiviNombre : any;
	responsableInfoFiviCargo : any;
	responsableInfoFiviTelefono : any;
	responsableInfoFiviCorreo : any;
	tipoViaPrincipal : any;
	nombreViaPrincipal : any;
	letraViaPrincipal : any;
	prefijo : any;
	cuadrante1 : any;
	numeroPrefijo1 : any;
	letraPrefijo : any;
	numeroPrefijo2 : any;
	cuadrante2 : any;
	complemento : any;
	numeroLetraComplemento : any;
}
